module.exports = __webpack_public_path__ + "assets/img/feipang--blue.52ccc358.png";